"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextValue = exports.SegmentedControlContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
exports.SegmentedControlContext = React.createContext({
    activeId: '',
});
exports.getContextValue = helper_1.createContextValueGetter();
